import { ErrorBoundary } from "react-error-boundary";
import { useGamePlay } from "../../../ducks/gamePlay";
import {
  ERROR_PLAYER,
  sendPingData,
  setError,
  setErrorMsg,
} from "../../../ducks/ping";
import { useUser } from "../../../ducks/user";
import Player from "./Player";
import UserTime from "./UserTime";

export default function UserPlayer() {
  const { gameEnded, isUserTurn, elo, previousElo } = useGamePlay();

  const { displayName, avatarId, fbId, isGuest, id, avatarType } = useUser();
  const user = {
    displayName,
    avatarId,
    fbId,
    isGuest,
    id,
    avatarType,
    elo,
    previousElo,
  };

  const isUser = true;
  const playerProps = {
    isUser,
    ...user,
    gameEnded,
    turn: isUserTurn,
  };

  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => null}
      onError={(error, info: { componentStack: string }) => {
        setError(ERROR_PLAYER);
        setErrorMsg({
          errorMsg:
            "UserPlayer4 " + error.message + " " + JSON.stringify(playerProps),
          componentStack: info.componentStack,
        });
        sendPingData();
      }}
    >
      <Player {...playerProps}>
        <UserTime isRunning={isUserTurn} />
      </Player>
    </ErrorBoundary>
  );
}
